// 画像アップロード前のクライアント側圧縮（デフォルト上限2MB）

export function fileToDataUrl(file) {
  return new Promise((resolve, reject) => {
    const rd = new FileReader();
    rd.onload = () => resolve(rd.result);
    rd.onerror = reject;
    rd.readAsDataURL(file);
  });
}

export function compressImage(dataUrl, maxBytes = 2 * 1024 * 1024) {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      let scale = Math.min(1, 1920 / img.width);
      let quality = 0.85;
      const canvas = document.createElement("canvas");
      const attempt = () => {
        canvas.width = Math.max(1, Math.round(img.width * scale));
        canvas.height = Math.max(1, Math.round(img.height * scale));
        const ctx = canvas.getContext("2d");
        ctx.fillStyle = "#ffffff";
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        return canvas.toDataURL("image/jpeg", quality);
      };
      let out = attempt();
      let guard = 0;
      // base64 dataURL のバイト数 ≒ 文字数 × 0.75
      while (out.length * 0.75 > maxBytes && guard < 12) {
        if (quality > 0.5) {
          quality -= 0.12;
        } else {
          scale *= 0.75;
          quality = 0.7;
        }
        out = attempt();
        guard++;
      }
      resolve(out);
    };
    img.onerror = () => resolve(dataUrl);
    img.src = dataUrl;
  });
}
